export const SET_DISPLAY_SIZES = 'SET_DISPLAY_SIZES';
export const SET_SIGNATURE_COLOR = 'SET_SIGNATURE_COLOR';
export const SET_SIGNATURE_DATE = 'SET_SIGNATURE_DATE';
export const SET_SIGNATURE_IMAGE = 'SET_SIGNATURE_IMAGE';
export const SET_SIGNATURE_PLACE = 'SET_SIGNATURE_PLACE';
export const SET_SIGNATURE_PROGRESS = 'SET_SIGNATURE_PROGRESS';
export const RESET_SIGNATURE = 'RESET_SIGNATURE';
export const RESET_SIGNATURE_PROGRESS = 'RESET_SIGNATURE_PROGRESS';
